import { create } from 'zustand';

export function readDisabledMcpProviders(settings: Record<string, unknown> | null | undefined): string[] {
  const raw = settings?.disabledMcpProviders;
  return Array.isArray(raw)
    ? [...new Set(raw.filter((id): id is string => typeof id === 'string').map(id => id.trim().toLowerCase()).filter(Boolean))]
    : [];
}

const keyFor = (accountId: string, mode: string) => JSON.stringify([accountId, mode]);

/** Only unsent drafts live here. Created conversations persist this choice in item settings. */
export const usePluginSelectionDraft = create<{
  drafts: Record<string, string[]>;
  setDraft: (accountId: string, mode: string, disabled: string[]) => void;
  takeDraft: (accountId: string, mode: string) => string[];
}>((set, get) => ({
  drafts: {},
  setDraft: (accountId, mode, disabled) => set(state => ({ drafts: {
    ...state.drafts, [keyFor(accountId, mode)]: [...disabled],
  } })),
  takeDraft: (accountId, mode) => {
    const key = keyFor(accountId, mode);
    const disabled = get().drafts[key] ?? [];
    set(state => { const { [key]: _, ...drafts } = state.drafts; return { drafts }; });
    return disabled;
  },
}));

export function readPluginSelectionDraft(accountId: string, mode: string): string[] {
  return usePluginSelectionDraft.getState().drafts[keyFor(accountId, mode)] ?? [];
}
